var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#3E0292",
    fillOpacity: 0.23,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#030D45",
    fillRule: "evenodd",
    d: "M13.813 17.25a6.187 6.187 0 1 1 12.375 0v6.417a.687.687 0 1 1-1.375 0V17.25a4.812 4.812 0 1 0-9.625 0v7.333a2.98 2.98 0 1 0 5.958 0v-6.416a1.146 1.146 0 1 0-2.292 0v5.5a.688.688 0 0 1-1.375 0v-5.5a2.52 2.52 0 1 1 5.042 0v6.416a4.354 4.354 0 1 1-8.708 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFiles);
export default __webpack_public_path__ + "static/media/uploadFiles.d2ae56faffedd70b5feca3f724876854.svg";
export { ForwardRef as ReactComponent };